import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

export default function setCategories() {
  var swiper = new Swiper('[data-categories-swiper]', {
    modules: [Autoplay],
    slidesPerView: 1,
    spaceBetween: 10,
    autoplay: {
      delay: 2500,
      disableOnInteraction: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 24,
        autoplay: {
          delay: 2500,
          disableOnInteraction: true,
        },
      },
    },
  });
}
